import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black via-gray-900/50 to-black relative overflow-hidden">
      {/* Background particles */}
      <div className="absolute inset-0 opacity-20">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className={`particle absolute w-1 h-1 bg-blue-300 rounded-full animate-sand-fall-${(i % 4) + 1}`}
            style={{
              left: `${10 + (i * 6)}%`,
              top: `${30 + (i * 4)}%`,
              animationDelay: `${i * 1.2}s`,
            }}
          />
        ))}
      </div>

      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-extralight text-white mb-8 tracking-wider animate-fade-in">
            {t('about.title')}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-start mb-20">
          {/* Todas las secciones de texto en la columna izquierda */}
          <div className="space-y-16">
            {/* Born from Emotion */}
            <div className="space-y-6">
              <div className="border-l-2 border-blue-400/30 pl-8">
                <h3 className="text-2xl font-light text-blue-200 mb-4 animate-slide-up">
                  {t('about.emotion.title')}
                </h3>
                <p className="text-gray-300 leading-relaxed text-lg animate-slide-up delay-100">
                  {t('about.emotion.description')}
                </p>
              </div>
            </div>

            {/* Beyond Identity */}
            <div className="space-y-6">
              <div className="border-l-2 border-blue-400/30 pl-8">
                <h3 className="text-2xl font-light text-blue-200 mb-6 animate-slide-up">
                  {t('about.identity.title')}
                </h3>
                <div className="space-y-4 text-gray-300 leading-relaxed">
                  <p className="animate-slide-up delay-100">
                    {t('about.identity.desc1')}
                  </p>
                  <p className="animate-slide-up delay-200">
                    {t('about.identity.desc2')}
                  </p>
                  <p className="animate-slide-up delay-300">
                    {t('about.identity.desc3')}
                  </p>
                  <p className="animate-slide-up delay-400">
                    {t('about.identity.desc4')}
                  </p>
                </div>
              </div>
            </div>

            {/* Timeless Resonance */}
            <div className="space-y-6">
              <div className="border-l-2 border-blue-400/30 pl-8">
                <h3 className="text-2xl font-light text-blue-200 mb-4 animate-slide-up">
                  {t('about.resonance.title')}
                </h3>
                <p className="text-gray-300 leading-relaxed text-lg animate-slide-up delay-100">
                  {t('about.resonance.description')}
                </p>
              </div>
            </div>
          </div>

          {/* Video único en la columna derecha */}
          <div className="relative rounded-lg overflow-hidden shadow-lg border border-white/10 sticky top-20">
            <video
              className="w-full h-auto object-cover"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source src="https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__video-upscaler__67831.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
        
        <div className="text-center mt-20">
          <div className="inline-block p-8 rounded-full border border-white/10 bg-gradient-to-br from-blue-900/20 to-transparent backdrop-blur-sm">
            <div className="text-lg font-light text-blue-200 italic">
              {t('about.quote')}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;